import React from "react";

import { StyledSVG } from "../StyledIcon";

export const TrophyIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path d="M12 16L12 18"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M18 3H6L6.67563 4.64687C6.88766 5.16369 6.95118 5.72944 6.85903 6.2804L6 11.4166H6.01333C6.17542 14.7039 8.17132 16 12 16C15.8287 16 17.8246 14.7039 17.9867 11.4166H18L17.141 6.2804C17.0488 5.72944 17.1123 5.16369 17.3244 4.64687L18 3Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 11C19.0609 11 20.0783 10.5786 20.8284 9.82843C21.5786 9.07828 22 8.06087 22 7C22 5.93913 21.5786 4.92172 20.8284 4.17157C20.0783 3.42143 19.0609 3 18 3"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5355 18.8787C16.4732 19.4413 17 20.2044 17 21L7 21C7 20.2043 7.52678 19.4413 8.46447 18.8787C9.40215 18.3161 10.6739 18 12 18C13.3261 18 14.5979 18.3161 15.5355 18.8787Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 11C4.93913 11 3.92172 10.5786 3.17157 9.82843C2.42143 9.07828 2 8.06087 2 7C2 5.93913 2.42143 4.92172 3.17157 4.17157C3.92172 3.42143 4.93913 3 6 3"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

</svg>
